import { trackEvent } from "@/utils/analytics";

export const trackPodcastsPageViewed = (): void => {
  trackEvent("podcasts.page_viewed", {
    category: "Podcasts",
    action: "page_viewed",
  });
};

interface PodcastCardClickParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackPodcastCardClick = (params: PodcastCardClickParams): void => {
  trackEvent("podcasts.podcast_card_clicked", {
    category: "Podcast Discovery",
    action: "podcast_card_clicked",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

interface PodcastDetailsViewParams {
  resourceType: string;
  resourceUuid: string;
}

export const trackPodcastDetailsView = (
  params: PodcastDetailsViewParams,
): void => {
  trackEvent("podcasts.podcast_details_viewed", {
    category: "Podcast Details",
    action: "podcast_details_viewed",
    resource_type: params.resourceType,
    resource_uuid: params.resourceUuid,
  });
};

export const trackPodcastFiltersChanged = (): void => {
  trackEvent("podcasts.podcast_filters_changed", {
    category: "Podcast Filters",
    action: "podcast_filters_changed",
  });
};
